import {connect} from 'react-redux';

import {CancelToken} from '../../../../../libs/shared/core/src/helpers/utilities/asyncCancelHelpers';
import {makeMapDispatchToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {fetchCardGroupsAndFilterPrivateNamespaceAsyncAction} from '../../../../store/data/cardGroups/cardGroupsActions';
import {ModifyCardGroupsDropdown} from './modifyCardGroupDropdown';

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  fetchCardGroupsAsync: (namespace: string, cancelToken?: CancelToken) =>
    fetchCardGroupsAndFilterPrivateNamespaceAsyncAction(namespace, false, cancelToken),
}));

export const ModifyCardGroupsDropdownContainer = connect(null, mapDispatchToProps)(ModifyCardGroupsDropdown);
